import { render, staticRenderFns } from "./statu-filter-btn.vue?vue&type=template&id=ed3519b2&scoped=true&"
import script from "./statu-filter-btn.vue?vue&type=script&lang=js&"
export * from "./statu-filter-btn.vue?vue&type=script&lang=js&"
import style0 from "./statu-filter-btn.vue?vue&type=style&index=0&id=ed3519b2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed3519b2",
  null
  
)

export default component.exports